import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import React from 'react';
import AppProvider from './hooks/index';
import RoutesList from './routes';
import GlobalStyle from './styles/global';
import theme from './styles/theme';

function App() {
    return (
        <>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <ChakraProvider theme={theme}>
                <AppProvider>
                    <RoutesList forceRefresh={true} />
                </AppProvider>
                <GlobalStyle />
            </ChakraProvider>
        </>
    );
}

export default App;
